<template>
  <div class="float-consult">
    <div class="float-btn" @click="showModal = true" title="立即咨询">
      <span class="glyphicon glyphicon-comment"></span>
      <span class="float-label">咨询报价</span>
    </div>
    <Modal v-model="showModal" title="获取方案报价" :footer-hide="true" width="480">
      <form @submit.prevent="submitForm">
        <div class="form-group">
          <label>姓名 <span class="req">*</span></label>
          <input v-model="form.name" class="form-control" placeholder="请输入您的姓名" />
        </div>
        <div class="form-group">
          <label>种植场景</label>
          <select v-model="form.scene" class="form-control">
            <option value="">请选择种植场景</option>
            <option v-for="s in plantScenes" :key="s" :value="s">{{ s }}</option>
          </select>
        </div>
        <div class="form-group">
          <label>需求描述 <span class="req">*</span></label>
          <textarea v-model="form.content" class="form-control" rows="4" placeholder="请描述您的项目需求"></textarea>
        </div>
        <div class="form-group">
          <label>联系方式 <span class="req">*</span></label>
          <input v-model="form.phone" class="form-control" placeholder="手机或座机" />
        </div>
        <button type="submit" class="btn-theme btn-block">提交咨询</button>
        <p class="consult-phone">
          或直接联系 <a href="javascript:;" class="copy-phone" @click.prevent="$copyText(config.mobile)" title="点击复制号码">{{ config.mobileContact }} {{ config.mobile }}</a>
        </p>
      </form>
    </Modal>
  </div>
</template>
<script>
import config from '@/config'
import { plantScenes } from '@/data/siteData'
import * as utils from '@/api/utils-v2'
import * as ResponseStatus from '@/api/response-status'

export default {
  name: 'FloatConsult',
  data() {
    return {
      config,
      plantScenes,
      showModal: false,
      form: { name: '', scene: '', content: '', phone: '', email: '' }
    }
  },
  methods: {
    submitForm() {
      if (!this.form.name || !this.form.phone || !this.form.content) {
        this.$Message.error('请填写姓名、联系方式和需求')
        return
      }
      const payload = {
        name: this.form.name,
        phone: this.form.phone,
        email: this.form.email || config.businessEmail,
        content: `[${this.form.scene || '未选择场景'}] ${this.form.content}`
      }
      this.$Spin.show()
      utils.doPostJson('/web-contactus/any/save', payload, {}).then(res => {
        this.$Spin.hide()
        if (res.data.code == ResponseStatus.OK) {
          this.$Message.success('提交成功，工程师将尽快联系您')
          this.showModal = false
          this.form = { name: '', scene: '', content: '', phone: '', email: '' }
        } else {
          this.$Message.error(res.data.message)
        }
      }).catch(() => {
        this.$Spin.hide()
        this.$Message.error('提交失败，请稍后重试')
      })
    }
  }
}
</script>
<style scoped>
.float-consult {
  position: fixed;
  right: 24px;
  bottom: 88px;
  z-index: 998;
}
.float-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 56px;
  padding: 12px 8px;
  background: linear-gradient(135deg, var(--color-agri), var(--color-primary));
  color: #fff;
  border-radius: 28px;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(46, 125, 50, 0.4);
  transition: var(--transition);
}
.float-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 28px rgba(46, 125, 50, 0.5);
}
.float-btn .glyphicon { font-size: 20px; margin-bottom: 4px; }
.float-label { font-size: 11px; font-weight: 600; writing-mode: vertical-rl; letter-spacing: 2px; }
.form-group { margin-bottom: 16px; }
.form-group label { display: block; margin-bottom: 6px; font-size: 14px; font-weight: 500; }
.req { color: #e74c3c; }
.btn-block { width: 100%; text-align: center; border: none; }
.consult-phone { text-align: center; margin-top: 14px; font-size: 13px; color: var(--color-text-muted); }
.consult-phone a { color: var(--color-primary); font-weight: 600; }
@media screen and (max-width: 768px) {
  .float-consult { right: 16px; bottom: 80px; }
  .float-btn { width: 48px; padding: 10px 6px; }
}
</style>



// WEBPACK FOOTER //
// src/components/FloatConsult.vue